import { ItemRecord } from './components/item/itemsReducer'
import { TagRecord } from './components/item/tagsReducer'
import { CategoryRecord } from './components/item/categoryReducer'
import { SourceRecord } from './views/Info/sourcesReducer'
import { MenuRecord } from './components/menu/menuReducer'
import { CustomFeedRecord } from './user/userReducer'

export default [ItemRecord, TagRecord, SourceRecord, CategoryRecord, MenuRecord, CustomFeedRecord]
